var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-content',{staticClass:"intro",attrs:{"blue":true}},[_c('com-content',{attrs:{"inner":true}},[_c('h1',[_vm._v("Get started")]),_c('p',[_vm._v("We'd love to have you join us - sign up below and we will be in touch with your login credentials and to help you settle in.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }